__turbopack_context__.v({
  "summary": "post-comments-and-likes-module-scss-module__xZAowq__summary",
});
